import { privateApi } from 'services';
import {
    CreateButtonWidget,
    CreateChatWidget,
    CreateFormWidget,
    Widget,
    ChatWidgetWithConfig,
} from './types.experimental';

const fetchWidgets = (businessAccountId: string): Promise<Widget[]> => {
    return privateApi.get<Widget[]>(`business-accounts/${businessAccountId}/website-widget/widgets`);
};

const fetchWidget = (websiteWidgetId: string): Promise<ChatWidgetWithConfig> => {
    return privateApi.get<ChatWidgetWithConfig>(`website-widget/widgets/${websiteWidgetId}`);
};

const create = async (
    businessAccountId: string,
    createWidget: CreateChatWidget | CreateButtonWidget | CreateFormWidget,
): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/website-widget/widgets`, createWidget);

const edit = async (
    widgetId: string,
    createWidget: CreateChatWidget | CreateButtonWidget | CreateFormWidget,
): Promise<void> => privateApi.put<void>(`website-widget/widgets/${widgetId}`, createWidget);

const enable = async (widgetId: string): Promise<void> =>
    privateApi.post<void>(`website-widget/widgets/${widgetId}/enable`);

const disable = async (widgetId: string): Promise<void> =>
    privateApi.post<void>(`website-widget/widgets/${widgetId}/disable`);

export const WidgetGateway = {
    fetchWidgets,
    fetchWidget,
    create,
    edit,
    enable,
    disable,
};
